module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("preact");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable-next-line:no-reference
/// <reference path="./typings.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
var WithCss_1 = __webpack_require__(2);
exports.WithCss = WithCss_1.default;
var WithGlobalCss_1 = __webpack_require__(5);
exports.WithGlobalCss = WithGlobalCss_1.default;
var config_1 = __webpack_require__(3);
exports.initializeWidgetConfiguration = config_1.initializeWidgetConfiguration;
exports.widgetConfiguration = config_1.widgetConfiguration;
var SgWidget_1 = __webpack_require__(10);
exports.SgWidget = SgWidget_1.SgWidget;
var preact_1 = __webpack_require__(0);
exports.h = preact_1.h;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = __webpack_require__(0);
/**
 * Inject CSS in your component tree
 * Pass-in a stringifiable object as a `styles` prop to have it injected in a `<style>` tag.
 */
var WithCss = function (_a) {
    var styles = _a.styles, children = _a.children;
    var styleContent = styles ? styles.toString() : null;
    return (preact_1.h("span", null,
        styleContent === null ? null : preact_1.h("style", null, styleContent),
        children));
};
exports.default = WithCss;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var toplevel_1 = __webpack_require__(4);
var WidgetConfiguration_1 = __webpack_require__(7);
/**
 * The singleton instance.
 * Initialized by a call to `initializeWidgetConfiguration(widget)`.
 */
var configInstance;
/**
 * Initialize and performs sanity checks for your widget.
 * @param widget Your widget contructor or its tag name.
 */
function initializeWidgetConfiguration(widget, options) {
    if (options === void 0) { options = {}; }
    var widgetTag = typeof widget === "string" ? widget : widget.is;
    if (configInstance) {
        configInstance.log("Widget configuration already initialized...try to prevent this");
    }
    var globalConfigAvailable = true;
    if (!toplevel_1.toplevel.SGWTWidgetConfiguration) {
        toplevel_1.toplevel.SGWTWidgetConfiguration = {};
        globalConfigAvailable = false;
    }
    configInstance = new WidgetConfiguration_1.WidgetConfiguration(widgetTag, toplevel_1.toplevel.SGWTWidgetConfiguration, options);
    performSanityChecks(configInstance, options);
    if (!globalConfigAvailable) {
        configInstance.log("[@sgwt-widget/core] WARNING: SGWTWidgetConfiration was not available. " +
            "It was set to an empty object. Please fix this.");
    }
}
exports.initializeWidgetConfiguration = initializeWidgetConfiguration;
/**
 * TESTS-ONLY: resetting the Widget configuration to the default.
 */
function resetWidgetConfiguration() {
    configInstance = undefined;
    if (toplevel_1.toplevel.SGWTWidgetConfiguration &&
        toplevel_1.toplevel.SGWTWidgetConfiguration.bus) {
        delete toplevel_1.toplevel.SGWTWidgetConfiguration.bus;
    }
}
exports.resetWidgetConfiguration = resetWidgetConfiguration;
function defaultConfiguration() {
    var configuration = new WidgetConfiguration_1.WidgetConfiguration("@sgwt-widget/core", {}, {});
    WidgetConfiguration_1.warnOrError(configuration, "initializeWidgetConfiguration(widgetConstructorORtagName) has not been called." +
        " Using a default configuration. Please report to the widget owner.");
    performSanityChecks(configuration);
    return configuration;
}
function widgetConfiguration() {
    return configInstance || defaultConfiguration();
}
exports.widgetConfiguration = widgetConfiguration;
function performSanityChecks(config, options) {
    if (options === void 0) { options = {}; }
    if (toplevel_1.toplevel.jQuery === undefined && !options.disablejQuerySanityCheck) {
        WidgetConfiguration_1.warnOrError(config, "[SANITYCHECK] jQuery is not available." +
            " Widgets might depend on it so you are on your own if you do not load it.");
    }
    if (typeof toplevel_1.toplevel.CustomElementRegistry === "undefined") {
        WidgetConfiguration_1.warnOrError(config, "[SANITYCHECK] It seems CustomElementRegistry is not defined at all." +
            " Are you sure the necessary polyfills are loaded ?");
    }
    if (toplevel_1.toplevel.fetch === undefined && !options.disableFetchSanityCheck) {
        WidgetConfiguration_1.warnOrError(config, "[SANITYCHECK] It seems fetch is not available." +
            " Are you sure the necessary polyfills are loaded ?");
    }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.toplevel = typeof window !== "undefined" ? window : global;
exports.supportShadowDom = exports.toplevel.HTMLElement !== undefined &&
    exports.toplevel.HTMLElement.prototype !== undefined &&
    exports.toplevel.HTMLElement.prototype.attachShadow !== undefined;
// tslint:disable:object-literal-sort-keys
exports.WidgetLogLevelValues = {
    debug: 10,
    info: 20,
    warn: 30,
    error: 40,
};
// tslint:enable:object-literal-sort-keys

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = __webpack_require__(0);
var config_1 = __webpack_require__(3);
var WithCss_1 = __webpack_require__(2);
/**
 * Injects custom style and the global style. This should be used only once
 * in your widget (usually at the toplevel).
 *
 * If you want to inject other styles at a lower level, use `<WithCss>`.
 */
exports.default = function (_a) {
    var styles = _a.styles, children = _a.children;
    var _b = config_1.widgetConfiguration(), sharedCssUrls = _b.sharedCssUrls, useShadowDOM = _b.useShadowDOM;
    var injectShared = useShadowDOM && sharedCssUrls !== undefined && sharedCssUrls.length !== 0;
    if (injectShared) {
        var cssContent = sharedCssUrls
            .map(function (url) { return "@import url(" + url + ");"; })
            .concat([styles ? styles.toString() : ""])
            .join("\n");
        return preact_1.h(WithCss_1.default, { styles: cssContent }, children);
    }
    else {
        return preact_1.h(WithCss_1.default, { styles: styles }, children);
    }
};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Bus_1 = __webpack_require__(8);
var scriptlocation_1 = __webpack_require__(9);
var toplevel_1 = __webpack_require__(4);
/**
 * configuration object available to widgets.
 */
var WidgetConfiguration = /** @class */ (function () {
    function WidgetConfiguration(widgetTag, globalConfig, configOptions) {
        this.widgetTag = widgetTag;
        this.globalConfig = globalConfig;
        this.configOptions = configOptions;
        this.fetchBind = toplevel_1.toplevel.fetch
            ? toplevel_1.toplevel.fetch.bind(toplevel_1.toplevel)
            : undefined;
        this.environment =
            (globalConfig.widgets &&
                globalConfig.widgets[widgetTag] &&
                globalConfig.widgets[widgetTag].environment) ||
                globalConfig.environment ||
                "production";
        this.fetch =
            globalConfig.fetch ||
                (toplevel_1.toplevel.fetch ? toplevel_1.toplevel.fetch.bind(toplevel_1.toplevel) : undefined);
        this.sharedCssUrls = globalConfig.sharedCssUrls || [];
        if (!this.globalConfig.bus) {
            this.initializeGlobalBus();
        }
    }
    Object.defineProperty(WidgetConfiguration.prototype, "bus", {
        /**
         * An instance of Bus that can be used to communicate with other widgets.
         */
        get: function () {
            if (!this.globalConfig.bus) {
                this.initializeGlobalBus();
            }
            return this.globalConfig.bus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WidgetConfiguration.prototype, "useShadowDOM", {
        /**
         * Should this widget use ShadowDOM if available.
         * This is based on the browser support and the configuration options `neverUseShadowDOM`.
         */
        get: function () {
            var configNeverUseShadowDOM = this.configOptions.neverUseShadowDOM
                ? this.configOptions.neverUseShadowDOM
                : false;
            return toplevel_1.supportShadowDom && !configNeverUseShadowDOM;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * basic log function that widgets should use instead of `console.log`
     */
    WidgetConfiguration.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["info", message].concat(optionalParams));
    };
    /**
     * log a message at the debug level.
     */
    WidgetConfiguration.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["debug", message].concat(optionalParams));
    };
    /**
     * log a message at the info level.
     */
    WidgetConfiguration.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["info", message].concat(optionalParams));
    };
    /**
     * log a message at the warn level.
     */
    WidgetConfiguration.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["warn", message].concat(optionalParams));
    };
    /**
     * log a message at the error level.
     */
    WidgetConfiguration.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        this.internalLog.apply(this, ["error", message].concat(optionalParams));
    };
    /**
     * `fetch` function that widgets should use to allow the application
     * to intercept/log network calls.
     */
    WidgetConfiguration.prototype.fetch = function (input, init) {
        var fetchFn = this.globalConfig.fetch || this.fetchBind;
        return fetchFn
            ? fetchFn(input, init)
            : Promise.reject("fetch not available");
    };
    WidgetConfiguration.prototype.myConfiguration = function () {
        var _this = this;
        this.myConfigurationPromise =
            this.myConfigurationPromise ||
                new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var location_1, configLocation, response, configurationData, e_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (this.globalConfig.widgets &&
                                    this.globalConfig.widgets[this.widgetTag] &&
                                    this.globalConfig.widgets[this.widgetTag].configuration) {
                                    resolve(this.globalConfig.widgets[this.widgetTag].configuration);
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 6, , 7]);
                                location_1 = scriptlocation_1.scriptLocation(this.widgetTag);
                                configLocation = "" + location_1.path + this.widgetTag + "." + this.environment + ".json";
                                return [4 /*yield*/, this.fetch(configLocation, {
                                        credentials: "include",
                                        headers: new Headers({ Accept: "application/json" }),
                                        method: "GET",
                                    })];
                            case 2:
                                response = _a.sent();
                                if (!!response.ok) return [3 /*break*/, 3];
                                resolve(undefined);
                                return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, response.json()];
                            case 4:
                                configurationData = _a.sent();
                                resolve(configurationData);
                                _a.label = 5;
                            case 5: return [3 /*break*/, 7];
                            case 6:
                                e_1 = _a.sent();
                                this.error("Could not load configuration", e_1);
                                resolve(undefined);
                                return [3 /*break*/, 7];
                            case 7: return [2 /*return*/];
                        }
                    });
                }); });
        return this.myConfigurationPromise;
    };
    WidgetConfiguration.prototype.initializeGlobalBus = function () {
        this.debug("Initializing global bus for all widgets.");
        this.globalConfig.bus = new Bus_1.Bus();
    };
    /**
     * Internal functions used for logging.
     *
     * If no custom logging function has been given, it will use the
     * various console.xxx methods.
     */
    WidgetConfiguration.prototype.internalLog = function (level, message) {
        var optionalParams = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            optionalParams[_i - 2] = arguments[_i];
        }
        var minimalLevel = this.globalConfig.logLevel ||
            (process.env.NODE_ENV === "production" ? "info" : "debug");
        if (toplevel_1.WidgetLogLevelValues[minimalLevel] > toplevel_1.WidgetLogLevelValues[level]) {
            return;
        }
        if (this.globalConfig.log) {
            (_a = this.globalConfig).log.apply(_a, [this.widgetTag, level, message].concat(optionalParams));
        }
        else {
            switch (level) {
                case "debug":
                    // tslint:disable-next-line:no-console
                    console.debug.apply(console, [this.widgetTag, level, message].concat(optionalParams));
                    break;
                case "info":
                    // tslint:disable-next-line:no-console
                    console.info.apply(console, [this.widgetTag, level, message].concat(optionalParams));
                    break;
                case "warn":
                    // tslint:disable-next-line:no-console
                    console.warn.apply(console, [this.widgetTag, level, message].concat(optionalParams));
                    break;
                case "error":
                    // tslint:disable-next-line:no-console
                    console.error.apply(console, [this.widgetTag, level, message].concat(optionalParams));
                    break;
                default:
                    // This ensures that we are not missing a case above
                    var exhaustiveCheck = level;
            }
        }
        var _a;
    };
    return WidgetConfiguration;
}());
exports.WidgetConfiguration = WidgetConfiguration;
function warnOrError(config, message) {
    if (process.env.NODE_ENV === "production") {
        config.warn("[@sgwt-widget/core] WARNING: " + message);
    }
    else {
        throw new Error("[@sgwt-widget/core] " + message);
    }
}
exports.warnOrError = warnOrError;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This class implements a pseudo bus that stores the latest value
 * sent on a given topic and will always trigger the callback at least once
 * upon subscribing.
 *
 * Close to a [BehaviorSubject from RxJS](https://github.com/ReactiveX/rxjs/blob/master/doc/subject.md#behaviorsubject)
 */
var Bus = /** @class */ (function () {
    function Bus() {
        this.subscribers = {};
        this.lastValues = {};
    }
    /**
     * Publish data on a given topic
     * @param topicName the topic name
     * @param payload the payload to publish
     */
    Bus.prototype.publish = function (topicName, payload) {
        this.lastValues[topicName] = payload;
        var topicSubscribers = this.subscribersForTopic(topicName);
        topicSubscribers.forEach(function (s) { return s(payload); });
    };
    /**
     * Subscribe to a given topic
     * @param topicName the topic name
     * @param cb will be called anytime the current value on the topic changes
     *  and at least once initially with the current value (or `undefined` if
     *  nothing has been published yet).
     * @return a subscription handle you need to use to unsubscribe.
     */
    Bus.prototype.subscribe = function (topicName, cb) {
        if (!cb || typeof cb !== "function") {
            return undefined;
        }
        var topicSubscribers = this.subscribersForTopic(topicName);
        topicSubscribers.push(cb);
        // Always publish the current value (even if it is undefined !)
        var currentValue = this.lastValues[topicName];
        cb(currentValue);
        // The handle contains the topic name and a reference to the callback
        return {
            cb: cb,
            topicName: topicName,
        };
    };
    /**
     * Stop a subscription.
     * @param subscription the subscription handle received from your subscribe call.
     */
    Bus.prototype.unsubscribe = function (handle) {
        var topicSubscribers = this.subscribersForTopic(handle.topicName);
        var subscriberIndex = topicSubscribers.indexOf(handle.cb);
        if (subscriberIndex !== -1) {
            topicSubscribers.splice(subscriberIndex, 1);
        }
    };
    /**
     * Get the current value of a given topic (`undefined` if nothing has been published yet).
     *
     * **WARNING**: You will not be notified when the value changes and this
     * can lead to strange bugs.
     * @param topicName the topic name
     */
    Bus.prototype.dangerouslyGetCurrentValue = function (topicName) {
        return this.lastValues[topicName];
    };
    Bus.prototype.subscribersForTopic = function (topicName) {
        var topicSubscribers = this.subscribers[topicName];
        if (!topicSubscribers) {
            this.subscribers[topicName] = topicSubscribers = [];
        }
        return topicSubscribers;
    };
    return Bus;
}());
exports.Bus = Bus;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Try to return the url of the script tag that loaded the current script.
 */
function scriptLocation(widgetTag) {
    var scriptTag = document.querySelector("script[src*=\"" + widgetTag + "\"]");
    if (!scriptTag) {
        return {
            file: "file.js",
            fileNoExt: "file",
            fullPath: "could://not/get/location/file.js?query",
            path: "ould://not/get/location/",
            query: "?query",
        };
    }
    var srcAttr = scriptTag.src;
    var pathParts = srcAttr.match(/((http[s]?:\/\/.+\/)([^\/]+\.[a-zA-Z]+)(\?[\w\d]+)?)/);
    if (pathParts) {
        var parts = pathParts[3].split(".");
        parts.length = parts.length !== 1 ? parts.length - 1 : 1;
        var fileNoExt = parts.join(".");
        return {
            file: pathParts[3],
            fileNoExt: fileNoExt,
            fullPath: pathParts[1],
            path: pathParts[2],
            query: pathParts[4] || "",
        };
    }
    else {
        return {
            file: "file.js",
            fileNoExt: "file",
            fullPath: "could://not/get/location/file.js?query",
            path: "ould://not/get/location/",
            query: "?query",
        };
    }
}
exports.scriptLocation = scriptLocation;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var withPreact = __webpack_require__(11);
var preact_1 = __webpack_require__(0);
var skatejs_1 = __webpack_require__(12);
var index_1 = __webpack_require__(1);
/**
 * Base class for SgWidget.
 *
 * Will manage the renderRoot depending on your configuration options
 */
var SgWidget = /** @class */ (function (_super) {
    __extends(SgWidget, _super);
    function SgWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SgWidget.prototype, "renderRoot", {
        get: function () {
            if (index_1.widgetConfiguration().useShadowDOM) {
                return (this._shadowRoot ||
                    (this._shadowRoot = this.shadowRoot || attachShadow(this)));
            }
            else {
                return this;
            }
        },
        enumerable: true,
        configurable: true
    });
    SgWidget.prototype.disconnectedCallback = function () {
        this.rendererCallback(this.renderRoot, function () { return preact_1.h("span", {}); });
    };
    return SgWidget;
}(skatejs_1.withComponent(withPreact(HTMLElement))));
exports.SgWidget = SgWidget;
function attachShadow(elem) {
    return elem.attachShadow ? elem.attachShadow({ mode: "open" }) : elem;
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("@skatejs/renderer-preact");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("skatejs");

/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sgwt-widget/core/lib/index.js
// module id = 5
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12